import { ErpSources } from 'enums/ErpSources';

export type Type = {
	ingredient: string[];
	type: 'id' | 'name';
	source: ErpSources[];
	cultureCode: string;
	isCatStrict: boolean;
	pageSize: number;
	pageIndex: number;
};

export function create(ingredient: Array<string | null>): Type {
	return {
		ingredient: ingredient[0] ? [ingredient[0]] : [],
		type: 'id',
		source: [ErpSources.SYSCO],
		cultureCode: '',
		isCatStrict: false,
		pageSize: 5,
		pageIndex: 0,
	};
}

export function reset(itemName: string): Type {
	return create([itemName]);
}
